export default function sortedList(categories) {
  const listCategories = []
  for (let category of categories) {
    if (category.showInList) {
      listCategories.push(category)
    }
  }

  return listCategories.sort((a,b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
}
